var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobal = function SvgGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.167a5.333 5.333 0 1 0 0 10.667A5.333 5.333 0 0 0 8 3.167Zm-4.714.62a6.667 6.667 0 1 1 9.428 9.428 6.667 6.667 0 0 1-9.428-9.428Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.167c-.285 0-.798.287-1.276 1.362C6.27 5.548 6 6.976 6 8.5c0 .75.066 1.49.192 2.175.127.687.31 1.296.532 1.796.224.505.472.862.71 1.084.234.218.426.278.566.278.14 0 .332-.06.566-.278.238-.222.487-.58.71-1.083.223-.5.406-1.11.532-1.797.127-.686.192-1.425.192-2.175 0-1.525-.27-2.953-.723-3.972C8.799 3.454 8.285 3.167 8 3.167Zm-2.495.82C6.028 2.811 6.871 1.834 8 1.834c1.13 0 1.973.977 2.495 2.153.548 1.232.839 2.855.839 4.514 0 .825-.073 1.646-.214 2.417a9.4 9.4 0 0 1-.625 2.096c-.271.61-.61 1.136-1.02 1.518-.413.385-.915.635-1.475.635s-1.062-.25-1.475-.635c-.409-.382-.748-.908-1.02-1.518a9.397 9.397 0 0 1-.624-2.096A13.452 13.452 0 0 1 4.667 8.5c0-1.659.291-3.282.838-4.514Z",
    fill: "#424242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.167H2V7.834h12v1.333Z",
    fill: "#424242"
  })));
};

export default SvgGlobal;